<template>
  <div v-if="modelValue" dir="rtl" class="col-lg-12 modal__for_fn rounded"
       :style="loading ? 'filter: blur(0.3vw);' : ''" style="width: 40vw; height: 40vw;">
    <div class="card card-body card-panel-box border-0 rounded"
         style="background-color: #F4FCFF; margin: 0; height: 40vw">
      <div class="row" style="height: 40vw">
        <div class="col-lg-12 ps-1" style="height: 40vw">
          <div class="card card-body card-panel-box border-0" style="height: 36vw;overflow-y: scroll">
            <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را ویرایش نمایید</h2>
            <form class="needs-validation" novalidate>
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">کد پرسنلی</label>
                  <input v-model="formData.personal_code" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">کدملی</label>
                  <input v-model="formData.national_code" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام</label>
                  <input v-model="formData.firstname" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام خانوادگی</label>
                  <input v-model="formData.lastname" class="form-control" type="text" required>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">فایل امضا ( JPG , JPEG ,PNG )</label>
                  <input id="file2" ref="fileInput" class="form-control d-block" type="file">
                  <small v-if="currentFiles.signature" class="text-muted text-small">فایل فعلی:
                    {{ currentFiles.signature }}</small>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label ">تصویر پروفایل ( JPG , JPEG ,PNG )</label>
                  <input id="file_profile2" ref="fileProfileInput" class="form-control d-block" type="file"
                         accept="image/png, .jpg, .jpeg">
                  <small v-if="currentFiles.profile" class="text-muted text-small">فایل فعلی: {{
                      currentFiles.profile
                    }}</small>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">شروع فعالیت</label>
                  <Vue3PersianDatetimePicker v-model="formData.start_date"></Vue3PersianDatetimePicker>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">پایان فعالیت</label>
                  <Vue3PersianDatetimePicker v-model="formData.end_date"></Vue3PersianDatetimePicker>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label">بارگزاری حکم ( JPG , JPEG ,PNG )</label>
                  <input id="decree_file" ref="decreeFileInput" class="form-control d-block" type="file">
                  <small v-if="currentFiles.decree" class="text-muted">فایل فعلی: {{ currentFiles.decree }}</small>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تلفن همراه</label>
                  <input v-model="formData.phone" class="form-control" type="number">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تلفن ثابت</label>
                  <input v-model="formData.tel" class="form-control" type="number">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">کد خط داخلی</label>
                  <input v-model="formData.code_tel" class="form-control" type="text">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">واحد سازمانی</label>
                  <input v-model="formData.address_activity" class="form-control" type="text">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label>پست سازمانی:</label>
                
 <v-select
  v-model="formData.post"
  :options="posts"
  label="name"
  :reduce="post => post.id"
  taggable
  @new="addNewPost"
  @update:modelValue="updatePostCurator"
  placeholder="یک پست سازمانی انتخاب یا اضافه کنید..."
  clearable
/>



                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">یادداشت</label>
                  <input v-model="formData.note" class="form-control" type="text">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تحصیلات</label>
                  <input v-model="formData.edu_level" class="form-control" type="text">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">سابقه کار</label>
                  <input v-model="formData.work_history_time" class="form-control" type="text">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label ">
                    دوره آموزشی چرخه مدیریت بهره‌وری را با موفقیت پشت‌سر گذاشته‌اند؟
                  </label>
                  <select v-model="formData.course_management" class="form-select">
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option :value="1">بله</option>
                    <option :value="0">خیر</option>
                  </select>
                </div>
              </div>

              <div v-if="formData.course_management === 1">
                <h4 style="font-size: 1vw !important">تکمیل اطلاعات دوره مقدماتی</h4>
                <div class="row">
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">تاریخ</label>
                    <Vue3PersianDatetimePicker v-model="formData.intro_date"></Vue3PersianDatetimePicker>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">مکان</label>
                    <textarea v-model="formData.intro_location" class="form-control" rows="3"></textarea>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">گواهینامه</label>
                    <select v-model="formData.has_intro_certificate" class="form-select">
                      <option value="" disabled selected>انتخاب کنید</option>
                      <option :value="1">دارد</option>
                      <option :value="0">ندارد</option>
                    </select>
                  </div>
                </div>
                <div class="row" v-if="formData.has_intro_certificate === 1">
                  <div class="col-lg-12 mb-3">
                    <label class="form-label">بارگزاری گواهینامه دوره مقدماتی ( JPG , JPEG ,PNG )</label>
                    <input id="intro_certificate_file" ref="introCertFileInput" class="form-control d-block"
                           type="file">
                    <small v-if="currentFiles.introCert" class="text-muted">فایل فعلی: {{
                        currentFiles.introCert
                      }}</small>
                  </div>
                </div>

                <h4 style="font-size: 1vw !important" class="mt-3">تکمیل اطلاعات دوره تکمیلی</h4>
                <div class="row">
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">تاریخ</label>
                    <Vue3PersianDatetimePicker v-model="formData.supplementary_date"></Vue3PersianDatetimePicker>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">مکان</label>
                    <textarea v-model="formData.supplementary_location" class="form-control" rows="3"></textarea>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">گواهینامه</label>
                    <select v-model="formData.has_supplementary_certificate" class="form-select">
                      <option value="" disabled selected>انتخاب کنید</option>
                      <option :value="1">دارد</option>
                      <option :value="0">ندارد</option>
                    </select>
                  </div>
                </div>
                <div class="row" v-if="formData.has_supplementary_certificate === 1">
                  <div class="col-lg-12 mb-3">
                    <label class="form-label">بارگزاری گواهینامه دوره تکمیلی ( JPG , JPEG ,PNG )</label>
                    <input id="supplementary_certificate_file" ref="suppCertFileInput" class="form-control d-block"
                           type="file">
                    <small v-if="currentFiles.suppCert" class="text-muted">فایل فعلی: {{
                        currentFiles.suppCert
                      }}</small>
                  </div>
                </div>
              </div>

              <div class="form-buttons row d-flex justify-content-around">
                <button @click.prevent="closeModal" class="btn btn-primary btn-back">برگشت</button>
                <button @click.prevent="submitForm" class="btn btn-primary btn-approve justify-content-evenly">
                  بروزرسانی
                  <span v-show="loading" class="loader"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, watch } from 'vue'
import { useToast } from "vue-toastification";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import cookies from "vue-cookies";
import { base_url } from "@/main";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'UserEditForm',

  components: {
    Vue3PersianDatetimePicker,
    vSelect,
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },

  emits: ['update:modelValue', 'user-updated', 'close-modal'],

  setup(props, { emit }) {
    const toast = useToast()
    const loading = ref(false)
    const fileInput = ref(null)
    const fileProfileInput = ref(null)
    const decreeFileInput = ref(null)
    const introCertFileInput = ref(null)
    const suppCertFileInput = ref(null)
const hasUserInteracted = ref(false)

    const posts = ref([])
  const previousPostId = ref(null)

 // لیست پست‌ها

    const formData = reactive({
      personal_code: '',
      national_code: '',
      firstname: '',
      lastname: '',
      start_date: '',
      end_date: '',
      phone: '',
      tel: '',
      code_tel: '',
      address_activity: '',
      post:null,  // اینجا مقدار پست انتخابی کاربر ذخیره می‌شود (مثلا نام پست)
      note: '',
      edu_level: '',
      work_history_time: '',
      course_management: 0,
      intro_date: '',
      intro_location: '',
      has_intro_certificate: 0,
      supplementary_date: '',
      supplementary_location: '',
      has_supplementary_certificate: 0,
    })

    const currentFiles = reactive({
      signature: '',
      profile: '',
      decree: '',
      introCert: '',
      suppCert: ''
    })

    // واکشی لیست پست‌های سازمانی از سرور
    const fetchPosts = async () => {
  try {
    const res = await fetch(`${base_url}/organization/post/all`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${cookies.get('token')}`,
      },
      body: JSON.stringify({})
    })
    if (!res.ok) throw new Error('خطا در دریافت لیست پست‌ها')
    const data = await res.json()
    
    // اطمینان از آرایه بودن داده
    posts.value = data.all
    console.log(data);

    // افزودن پست انتخاب شده کاربر اگر در لیست نبود
    if (formData.post && !posts.value.find(p => p.id === formData.post)) {
  // فرض میکنیم که نام پست هم باید داشته باشیم
  posts.value.push({ id: formData.post, name: 'پست قبلی' }) 
  // اگر نام پست رو داری، بذارش اینجا
}
  } catch (err) {
    console.error(err)
    toast.error('خطا در دریافت لیست پست‌ها')
  }
}


const updatePostCurator = async (postId, curatorId) => {
  try {
    const response = await fetch(`${base_url}/organization/post/update_other/${postId}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('token')}`,
      },
      body: JSON.stringify({
        curator: curatorId // یا props.user.id یا null
      }),
    });

    const data = await response.json();

    if (!response.ok) throw data;

    if (curatorId) {
      toast.success('پست سازمانی با موفقیت به کاربر اختصاص یافت.')
    } else {
      toast.success('پست قبلی از کاربر جدا شد.')
    }
  } catch (err) {
    toast.error('خطا در آپدیت متصدی پست سازمانی.')
    console.error(err);
  }
}




    // افزودن پست جدید به سرور و لیست
    const addNewPost = async (newPostName) => {
      try {
        const res = await fetch(`${base_url}/organization/post/store`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${cookies.get('token')}`,
          },
          body: JSON.stringify({ name: newPostName })
        })
        if (!res.ok) throw new Error('خطا در ذخیره پست جدید')
        const newPost = await res.json()

        // افزودن به لیست اگر نبود
        if (!posts.value.find(p => p.name === newPost.name)) {
          posts.value.push(newPost)
        }
        formData.post = newPost.name
        toast.success('پست جدید اضافه شد.')
      } catch (err) {
        console.error(err)
        toast.error('خطا در ذخیره پست جدید')
      }
    }

    // مقداردهی فرم از user ورودی و واکشی لیست پست‌ها
    const formatUser = async (userData) => {
      Object.keys(formData).forEach(key => {
        if (userData[key] !== undefined) {
          formData[key] = userData[key]
        }
      })
      formData.course_management = userData.course_management ?? 0
      formData.has_intro_certificate = userData.has_intro_certificate ?? 0
      formData.has_supplementary_certificate = userData.has_supplementary_certificate ?? 0
      previousPostId.value = userData.organization_post.id ?? null
      formData.post = userData.organization_post.id ?? null // شناسه پست قبلی
      currentFiles.signature = userData.file || ''
      currentFiles.profile = userData.image || ''
      currentFiles.decree = userData.decree_file || ''
      currentFiles.introCert = userData.intro_certificate_file || ''
      currentFiles.suppCert = userData.supplementary_certificate_file || ''

      await fetchPosts()
    }

    watch(() => props.user, (newUser) => {
  if (!newUser) return
  formatUser(newUser)
}, { immediate: true })

watch(() => formData.post, async (newPostId) => {
  if (!newPostId || newPostId === previousPostId.value) {
  return
  }

  // پست جدید رو ست کن
  await updatePostCurator(newPostId, props.user.id)

  // پست قبلی رو جدا کن
  if (previousPostId.value) {
    await updatePostCurator(previousPostId.value, null)
  }

  // مقدار جدید رو ذخیره کن به‌عنوان پست قبلی
  previousPostId.value = newPostId
})



// 2. وقتی پست تغییر کرد، درخواست POST به API ارسال شود


    const validateRequiredFields = () => {
      if (!formData.personal_code) {
        toast.error('کد پرسنلی اجباری است!')
        return false
      }
      if (!formData.national_code) {
        toast.error('کدملی اجباری است!')
        return false
      }
      if (!formData.firstname) {
        toast.error('نام اجباری است!')
        return false
      }
      if (!formData.lastname) {
        toast.error('نام خانوادگی اجباری است!')
        return false
      }
      return true
    }

    const closeModal = () => {
      emit('close-modal')
      emit('update:modelValue', false)
    }

    const handleError = (error) => {
      const message = 'عملیات با موفقیت انجام نشد.'
      if (error.error) {
        toast.error(error.error)
        throw new Error(message)
      }

      if (error.errors) {
        Object.entries(error.errors).forEach((value) => {
          toast.error(value[1][0])
        })
        throw new Error(message)
      }
    }

    const submitForm = async () => {
      if (!validateRequiredFields()) return

      loading.value = true
      const submitData = new FormData()

      Object.keys(formData).forEach(key => {
        if (formData[key] !== null) {
          submitData.append(key, formData[key])
        }
      })
      submitData.append('fullname', formData.firstname + ' ' + formData.lastname)

      if (fileInput.value?.files[0]) {
        submitData.append('file', fileInput.value.files[0])
      }
      if (fileProfileInput.value?.files[0]) {
        submitData.append('file_profile', fileProfileInput.value.files[0])
      }
      if (decreeFileInput.value?.files[0]) {
        submitData.append('decree_file', decreeFileInput.value.files[0])
      }
      if (introCertFileInput.value?.files[0]) {
        submitData.append('intro_certificate_file', introCertFileInput.value.files[0])
      }
      if (suppCertFileInput.value?.files[0]) {
        submitData.append('supplementary_certificate_file', suppCertFileInput.value.files[0])
      }

      try {
        const response = await fetch(`${base_url}/user/update/${props.user.id}`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${cookies.get('token')}`,
          },
          body: submitData,
        })

        const data = await response.json()

        handleError(data)

        toast.success('اطلاعات کاربر با موفقیت بروزرسانی شد!')
        emit('user-updated')
        closeModal()
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      formData,
      currentFiles,
      fileInput,
      fileProfileInput,
      decreeFileInput,
      introCertFileInput,
      suppCertFileInput,
      posts,
      submitForm,
      closeModal,
      formatUser,
      addNewPost,
    }
    
  }

 

}
</script>


<style scoped>
.text-small {
  font-size: .8vw;
}
</style>
